function f2169() {
  this.buffer = [];
  this.length = 0;
}
f2169.prototype = {
  get: function (p18199) {
    const v14015 = Math.floor(p18199 / 8);
    return (this.buffer[v14015] >>> 7 - p18199 % 8 & 1) == 1;
  },
  put: function (p18200, p18201) {
    for (let vLN02563 = 0; vLN02563 < p18201; vLN02563++) {
      this.putBit((p18200 >>> p18201 - vLN02563 - 1 & 1) == 1);
    }
  },
  getLengthInBits: function () {
    return this.length;
  },
  putBit: function (p18202) {
    const v14016 = Math.floor(this.length / 8);
    if (this.buffer.length <= v14016) {
      this.buffer.push(0);
    }
    if (p18202) {
      this.buffer[v14016] |= 128 >>> this.length % 8;
    }
    this.length++;
  }
};
module.exports = f2169;